<template>
  <div>
    <Breadcrumbs main="Kategoriler" title="Liste" :links="breadLinks" />

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <label class="sr-only" for="inline-form-input-name"
                >Kategori</label
              >
              <b-form-select
                id="filtre_tipi"
                v-model="filtre_tipi"
                :options="filtre_tipler"
                @change="onFiltreTipChange"
                class="mb-2 mr-sm-2 mb-sm-0"
              ></b-form-select>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <c-table :tablefields="tablefields" :items="items">
                <template #cell(Islem)="row">
                  <b-btn-group>
                    <router-link
                      :to="`/kategori/kayit/${row.item.Id}`"
                      class="btn btn-success btn-xs"
                      >Düzelt</router-link
                    >
                    <b-button size="xs" @click="sil(row.item)" variant="danger"
                      >Sil</b-button
                    >
                  </b-btn-group>
                </template>
                <template #cell(Aktif)="data">
                  <c-aktif-cell :isAktif="data.value"></c-aktif-cell>
                </template>
                <template #cell(KayitTarihi)="row">
                  <c-tarih-cell
                    :kayitTarihi="row.item.KayitTarihi"
                    :guncelTarih="row.item.GuncelTarih"
                    :rowKey="row.item.Id"
                  ></c-tarih-cell>
                </template>
              </c-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      breadLinks: [{ path: "/kategori/kayit", title: "Ekle", icon: "plus" }],
      tablefields: [
        { key: "Islem", label: "İşlemler", sortable: false },
        { key: "TipiStr", label: "Tipi", sortable: true },
        { key: "Tanim", label: "Kategori Adı", sortable: true },
        { key: "Aktif", label: "Aktif", sortable: true },
        { key: "Sira", label: "Sıra", sortable: true },
        { key: "KullaniciAdi", label: "Kullanıcı", sortable: true },
        { key: "KayitTarihi", label: "Kayıt Tarihi", sortable: true },
      ],

      items: [],

      filtre_tipi: 1,
      filtre_tipler: [],
    };
  },
  mounted() {
    this.onTipler();
    this.onList();
  },
  methods: {
    onTipler() {
      let vm = this;

      this.$connection.get("/kategoriler/KategoriTipleri", function (response) {
        vm.filtre_tipler = response;
      });
    },
    onFiltreTipChange() {
      this.onList();
    },
    onList() {
      let vm = this;

      this.$connection.get(
        "/kategoriler/all/" + vm.filtre_tipi,
        function (response) {
          vm.items = response;
        }
      );
    },
    sil(item) {
      let vm = this;
      this.$alert.confirm(
        "Sil",
        "Kategori kaydını silmek istediğinize emin misiniz?",
        "warning",
        function () {
          vm.$connection.delete("/kategoriler/" + item.Id, function (response) {
            vm.$alert.messageWithFunction(
              "Silindi",
              "Kategori kaydı silindi.",
              "error",
              function () {
                vm.$listHelper.removeItem(vm.items, item);
              }
            );
          });
        }
      );
    },
  },
};
</script>
